import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../components/header";
import Select from "react-select";
import Footer from "../components/footer";
import { Api, socket, getCurrency } from "../services/webservices";
import { ClipLoader } from "react-spinners";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import {
  validateMargin,
  validateMintransActionLimit,
  validateMaxtransActionLimit,
  validateRestrictAmount,
  validatetermTrade,
  validateaddTag,
  validatesetPaymentWindow,
} from "../utils/validation";
import locationJson from "../JSON/country.json";
// import currencyJson from "../JSON/currency.json"
import identity_doc from "../JSON/Identity.json";
import { toast_func } from "../components/toaster";
import "react-toastify/dist/ReactToastify.css";
import { base32 } from "../services/Decrypt";
import { ToastContainer, toast } from "react-toastify";
import { WithContext as ReactTags } from "react-tag-input";
import CreatableSelect from "react-select/lib/Creatable";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import CurrencyModal from "../components/currencyModal";
import $ from "jquery";
import renderHTML from "react-render-html";
const KeyCodes = {
  comma: 188,
  enter: 13,
};
const suggestions = [
  { value: "10", label: "10" },
  { value: "15", label: "15" },
  { value: "20", label: "20" },
  { value: "25", label: "25" },
  { value: "50", label: "50" },
  { value: "100", label: "100" },
];

let currencyJson = [];

const delimiters = [KeyCodes.comma, KeyCodes.enter];
export default class EditAdvertise extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currencyModal: false,
      priceData: "0",
      profit: 0,
      current: "",
      _id: "",
      loading: false,
      trade_type: "",
      trade_type1: false,
      trade_type2: false,
      loading: false,
      trade_typeError: "",
      location: "",
      locationError: "",
      currency: "",
      currencyError: "",
      margin: "",
      marginError: "",
      marginStatus: false,
      minTransactionLimit: "",
      minTransactionLimitError: "",
      minTransactionLimitStatus: false,
      maxTransactionLimit: "",
      maxTransactionLimitError: "",
      maxTransactionLimitStatus: false,
      restrictAmount: "",
      restrictAmountError: "",
      restrictAmountStatus: false,
      termTrade: localStorage.getItem("tradeTerm"),
      termTradeError: "",
      termTradeStatus: false,
      addTag: "",
      addTagError: "",
      addTagStatus: false,
      setPaymentWindow: "",
      setPaymentWindowError: "",
      setPaymentWindowStatus: false,
      btcAmount: "",
      btcAmountError: "",
      identityPeopleChecked: false,
      smsVerificationChecked: false,
      trustedPeopleChecked: false,
      BTCStatus: false,
      BTC: "",
      BTCError: "",
      BTCStatus: false,
      paymentMode: "",
      paymentModeError: "",
      paymentMethod: [],
      paymentMethodS: [],
      paymethods: false,
      userInfo: "",
      product_images: [],
      suggestions: [],
      Amount: "",
      selectedOption: null,
      selectedOption1: null,
      currency: "INR",
      currency1: "INR",
      keyPress: false,
      bse64data: "",
      bse64data1: "",
      imageArr: [],
    };
    this.getBase64 = this.getBase64.bind(this);
    this.setValue = this.setValue.bind(this);
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
  };
  handleChange1 = (selectedOption1) => {
    if (selectedOption1.length !== 0) {
      var check = parseInt(selectedOption1[0].value);
      var check1 = selectedOption1[selectedOption1.length - 1].value.split("");
      for (var i = 0; i < check1.length; i++) {
        if (check1[i] >= 0 && check1[i] <= 9) {
          this.setState({ allow: true });
        } else {
          return;
        }
      }
    } else if (selectedOption1.length == 0) {
      this.setState({ selectedOption1, allow: false });
    }
    setTimeout(() => {
      if (this.state.allow) {
        if (
          Number(selectedOption1[selectedOption1.length - 1].value) <=
            Number(this.state.maxTransactionLimit) &&
          Number(selectedOption1[selectedOption1.length - 1].value) >=
            Number(this.state.minTransactionLimit)
        ) {
          this.setState({ selectedOption1, allow: false });
        }
      }
    }, 100);
  };

  componentDidMount = async () => {
    window.scrollTo(0, 0);
    currencyJson = await getCurrency();

    var addr = localStorage.getItem("Address");
    var id = localStorage.getItem("data");
    var token = localStorage.getItem("token");

    var DecryptData = base32.decode(this.props.match.params._id);
    setTimeout(() => {
      this.setState({ _id: id, token: token, addr: addr }, () =>
        this.stateApis(DecryptData)
      );
    }, 300);
    this.fetchAmount();
    this.setState({ adId: DecryptData });

    // this.setState({ loading: true })
    Api(
      "trade/paymentMethodList",
      "GET",
      {},
      this.state.token,
      this.state._id
    ).then((resp) => {
      this.setState({ loading: false });

      try {
        this.setState({ loading: false });

        if ((resp.status = 200)) {
          if (resp.data.responseCode == 200) {
            this.setState({
              paymentMethod: resp.data.result,
              paymentMethodS: resp.data.result,
            });
          } else toast_func("error", resp.data.responseMessage);
        } else if (resp.data.responseCode == 502) {
          this.props.history.push("NotFound");
        } else toast_func("error", resp.data.responseMessage);
      } catch (ex) {
        toast_func(
          "error",
          "Some problem occured please contact administrator"
        );
      }
    });
    setTimeout(() => {
      Api("trade/tagList", "GET", {}, this.state.token, this.state._id).then(
        (resp) => {
          try {
            this.setState({ loading: false });

            if ((resp.status = 200)) {
              if (
                resp.data.responseCode == 409 ||
                resp.data.responseCode == 410 ||
                resp.data.responseCode == 411
              ) {
                localStorage.removeItem("data");
                localStorage.removeItem("isLoggedin");
                localStorage.removeItem("data1");
                localStorage.removeItem("token");
                this.props.history.push("/");
              } else if (resp.data.responseCode == 502) {
                this.props.history.push("NotFound");
              } else if (resp.data.responseCode == 200) {
                let arrdata = [];

                if (resp.data.result.length) {
                  for (var i = 0; i < resp.data.result.length; i++) {
                    let data1 = {
                      value: resp.data.result[i].tagName,
                      label: resp.data.result[i].tagName,
                    };
                    // this.state.tagList["id"]=resp.data.result[i].tagName
                    if (resp.data.result[i].tagName !== null) {
                      arrdata.push(data1);
                    }
                  }
                  this.setState({ suggestions: arrdata });
                }
                setTimeout(() => {}, 100);
              }
            }
          } catch (ex) {}
        }
      );
    }, 100);

    $(window).scroll(function() {
      //console.log("shoeeaaaaaaaaaaaa   ")
      //alert("ddddd")
      var scroll = $(window).scrollTop();
      if (scroll >= 50) {
        $("header").addClass("header-bg");
        $(".fixedBox").addClass("fixdtop");
      } else {
        $("header").removeClass("header-bg");
        $(".fixedBox").removeClass("fixdtop");
      }
    });
  };
  setValue(value) {
    // this.setState({ currencyModal: false })
    console.log("Asi==>", value);
    this.setState({ currency1: value, currencyModal: false }, () => {
      this.fetchAmount();
      this.fetch();
    });
  }
  fetchAmount() {
    var parameter = {
      localCurrency: this.state.currency1,
      margin: this.state.margin,
    };
    if (this.state.currency1 !== "") {
      this.setState({ loading1: true });
      Api(
        "user/priceEquationWithMargin",
        "POST",
        parameter,
        this.state.token,
        this.state._id
      ).then((resp) => {
        this.setState({ loading1: false });
        // alert(JSON.stringify(resp))
        if (resp.status == 200) {
          if (resp.data.responseCode == 200) {
            var num = Number(resp.data.result["price"]);
            var n = num.toFixed(8);
            var n1 = n
              .split(".")[0]
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            var n2 = n.split(".")[1];
            var price = n1 + "." + n2;
            //alert(JSON.stringify(resp.data.result["price"]))
            //this.setState({Amount})

            if (resp.data.result["margin"] == this.state.margin) {
              this.setState({
                price: price,
                price1: resp.data.result["price"],
              });
            } else {
              this.fetchAmount();
            }
            //alert(JSON.stringify(resp.data.result["price"]))
            //this.setState({Amount})
          } else if (resp.data.responseCode == 502) {
            this.props.history.push("NotFound");
          }
        }
      });
    }
  }
  fetch = () => {
    socket.emit("currentBTCValue", {
      localCurrency: `${this.state.currency1}`,
    });

    socket.on("currentBTCValue", (resp) => {
      this.setState({ current: resp.result.price.toFixed(2) });
    });
  };
  onClick_currency1 = (e) => {
    e.preventDefault();
    var value = e.target.value;
    this.setState({ currency1: value, currencyError: "" }, () =>
      this.fetchAmount()
    );
  };
  Populate_currency1 = () => {
    let currencyArray = [];
    for (var i = 0; i < currencyJson.length; i++) {
      currencyArray.push(<option key={i}>{currencyJson[i].code}</option>);
    }
    return currencyArray;
  };
  stateApis = (DecryptData) => {
    this.fetchData(DecryptData);
    Api("user/getUser", "GET", {}, this.state.token, this.state._id).then(
      (resp) => {
        this.setState({ loading: false });
        try {
          if ((resp.status = 200)) {
            this.setState({ loading: false });
            if (
              resp.data.responseCode == 409 ||
              resp.data.responseCode == 410 ||
              resp.data.responseCode == 411
            ) {
              // localStorage.clear();
              // this.props.history.push("/")
            } else if (resp.data.responseCode == 502) {
              this.props.history.push("NotFound");
            }
          } else {
          }
        } catch (ex) {}
      }
    );
    return;
    Api(
      `user/deposits_save/${this.state.addr}/${this.state._id}`,
      "GET",
      {},
      this.state.token,
      this.state._id
    );
    Api(
      `user/transferToAdminAccount/${this.state.addr}/${this.state._id}`,
      "GET",
      {},
      this.state.token,
      this.state._id
    );
  };
  onClick_tradeType = (e) => {
    e.preventDefault();
    var value = e.target.value;
    this.setState({ trade_type: value, trade_typeError: "" });
  };
  Populate_location = () => {
    let locationArray = [];
    for (var i = 0; i < locationJson.length; i++) {
      locationArray.push(<option key={i}>{locationJson[i].name}</option>);
    }
    return locationArray;
  };
  onClick_location = (e) => {
    e.preventDefault();
    var value = e.target.value;
    if (value == "Select") {
      this.setState({ location: "", locationError: "" });
    } else this.setState({ location: value, locationError: "" });
  };
  Populate_currency = () => {
    let currencyArray = [];
    for (var i = 0; i < currencyJson.length; i++) {
      currencyArray.push(<option key={i}>{currencyJson[i].code}</option>);
    }
    return currencyArray;
  };
  onClick_currency = (e) => {
    e.preventDefault();
    var value = e.target.value;
    this.setState({ currency: value, currencyError: "" });
  };
  Populate_paymentMethod = () => {
    let paymentArray = [];
    for (var i = 0; i < this.state.paymentMethod.length; i++) {
      paymentArray.push(
        <option key={i}>{this.state.paymentMethod[i].name}</option>
      );
    }

    return paymentArray;
  };
  fetchData(DecryptData) {
    let images = [];
    this.setState({ loading: true });
    Api(
      `trade/detail_trade/${DecryptData}`,
      "GET",
      {},
      this.state.token,
      this.state._id
    ).then((resp) => {
      this.setState({ loading: false });
      try {
        this.setState({ loading: false });

        if ((resp.status = 200)) {
          if (resp.data.responseCode == 200) {
            this.setState({ userInfo: resp.data.result }, () =>
              this.saveData()
            );
            this.fetch();
            console.log(
              "RRRR-====>" + JSON.stringify(resp.data.result.terms_of_trade)
            );
          } else if (resp.data.responseCode == 502) {
            this.props.history.push("NotFound");
          } else toast_func("error", resp.data.responseMessage);
        } else toast_func("error", resp.data.responseMessage);
      } catch (ex) {
        toast_func(
          "error",
          "Some problem occured please contact administrator"
        );
      }
    });
  }
  saveData = () => {
    if (this.state.userInfo.type_of_trade_original == "sell")
      this.setState({ trade_type1: true });
    else if (this.state.userInfo.type_of_trade_original == "buy")
      this.setState({ trade_type2: true });
    if (this.state.userInfo.location != undefined)
      this.setState({ location: this.state.userInfo.location });
    if (this.state.userInfo.currency_type != undefined)
      this.setState({ currency1: this.state.userInfo.currency_type });
    if (this.state.userInfo.margin != undefined)
      this.setState(
        { margin: this.state.userInfo.margin, marginStatus: true },
        () => this.fetchAmount()
      );
    if (this.state.userInfo.min_transaction_limit != undefined)
      this.setState({
        minTransactionLimit: this.state.userInfo.min_transaction_limit,
      });
    if (this.state.userInfo.max_transaction_limit != undefined)
      this.setState({
        maxTransactionLimit: this.state.userInfo.max_transaction_limit,
      });
    //if (this.state.userInfo.restrict_amount != undefined) this.setState({ restrictAmount: this.state.userInfo.restrict_amount })
    if (this.state.userInfo.terms_of_trade != undefined)
      this.setState({ termTrade: this.state.userInfo.terms_of_trade });
    if (this.state.userInfo.payment_method != undefined)
      this.setState({ paymentMode: this.state.userInfo.payment_method }, () =>
        this.setpaymentId()
      );
    if (this.state.userInfo.payment_time != undefined)
      this.setState({ setPaymentWindow: this.state.userInfo.payment_time });
    if (this.state.userInfo.sell_Amount != undefined)
      this.setState({ BTC: this.state.userInfo.sell_Amount });
    if (this.state.userInfo.product_images != undefined)
      this.setState({ product_images: this.state.userInfo.product_images });

    if (this.state.userInfo.security_options != undefined) {
      this.setState({
        identityPeopleChecked: this.state.userInfo.security_options
          .identfifed_people,
        smsVerificationChecked: this.state.userInfo.security_options
          .sms_verification,
        trustedPeopleChecked: this.state.userInfo.security_options
          .trusted_people,
      });
    }
    if (this.state.userInfo.add_tags != undefined) {
      var _index = this.state.paymentMethod.findIndex(
        (x) => x.name == this.state.userInfo.payment_method
      );

      let array_ = [];
      //this.setState({ selectedOption: this.state.userInfo.add_tags })
      for (var i = 0; i < this.state.userInfo.add_tags.length; i++) {
        var tags = {
          value: `${this.state.userInfo.add_tags[i]}`,
          label: `${this.state.userInfo.add_tags[i]}`,
        };
        array_.push(tags);
      }
      this.handleChange(array_);
    }

    if (this.state.userInfo.restrict_amount != undefined) {
      let arr = [];
      //var _index = suggestions.findIndex(x => x.label ==  this.state.userInfo.restrict_amount)
      for (var i = 0; i < this.state.userInfo.restrict_amount.length; i++) {
        var restrictValue = {
          value: `${this.state.userInfo.restrict_amount[i]}`,
          label: `${this.state.userInfo.restrict_amount[i]}`,
        };
        arr.push(restrictValue);
      }

      this.handleChange1(arr);
    }
  };
  setpaymentId() {
    setTimeout(() => {
      var _index = this.state.paymentMethod.findIndex(
        (x) => x.name == this.state.userInfo.payment_method
      );
      //alert(_index)
      this.setState({ paymentId: this.state.paymentMethod[_index]._id });
    }, 200);
  }
  onClick_paymentMethod = (e) => {
    e.preventDefault();
    var value = e.target.value;

    var _index = this.state.paymentMethod.findIndex((x) => x.name == value);

    if (value == "Select") {
      this.setState({ paymentMode: "", paymentModeError: "" });
    } else {
      this.setState({
        paymentMode: value,
        paymentModeError: "",
        paymentId: this.state.paymentMethod[_index]._id,
      });
    }
  };
  verify = (type, value) => {
    if (type === "trade_type") {
      if (this.state.trade_type == "") {
        this.setState({ trade_typeError: "*Please select at lease one trade" });
      } else this.setState({ trade_typeError: "" });
    } else if (type === "location") {
      if (this.state.location == "" || this.state.location == "Select") {
        this.setState({ locationError: "*Please select location" });
      } else this.setState({ locationError: "" });
    } else if (type === "currency") {
      if (this.state.currency == "" || this.state.currency == "Select") {
        this.setState({ currencyError: "*Please select currency" });
      } else this.setState({ currencyError: "" });
    }

    // else if (type === 'margin') {
    //     this.fetchAmount();
    //     if (this.state.margin != "") {
    //         this.setState({ marginError: "", marginStatus: true })
    //     } else this.setState({ marginError: validateMargin(this.state.margin).error, marginStatus: false })
    // }
    else if (type === "minTransactionLimit") {
      if (validateMintransActionLimit(this.state.minTransactionLimit).status) {
        this.setState({
          minTransactionLimitError: "",
          minTransactionLimitStatus: true,
        });
      } else
        this.setState({
          minTransactionLimitError: validateMintransActionLimit(
            this.state.minTransactionLimit
          ).error,
          minTransactionLimitStatus: false,
        });
    } else if (type === "maxTransactionLimit") {
      if (validateMaxtransActionLimit(this.state.maxTransactionLimit).status) {
        this.setState({
          maxTransactionLimitError: "",
          maxTransactionLimitStatus: true,
        });
      } else
        this.setState({
          maxTransactionLimitError: validateMaxtransActionLimit(
            this.state.maxTransactionLimit
          ).error,
          maxTransactionLimitStatus: false,
        });
    }

    // else if (type === 'restrictAmount') {
    //     if (validateRestrictAmount(this.state.restrictAmount).status) {
    //         this.setState({ restrictAmountError: "", restrictAmountStatus: true })
    //     } else this.setState({ restrictAmountError: validateRestrictAmount(this.state.restrictAmount).error, restrictAmountStatus: false })
    // }
    else if (type === "termTrade") {
      if (validatetermTrade(this.state.termTrade).status) {
        this.setState({ termTradeError: "", termTradeStatus: true });
      } else
        this.setState({
          termTradeError: validatetermTrade(this.state.termTrade).error,
          termTradeStatus: false,
        });
    }

    // else if (type === 'addTag') {
    //     if (validateaddTag(this.state.addTag).status) {
    //         this.setState({ addTagError: "", addTagStatus: true })
    //     } else this.setState({ addTagError: validateaddTag(this.state.addTag).error, addTagStatus: false })
    // }
    // else if (type === 'BTC') {
    //     if (this.state.BTC !== "") {
    //         this.setState({ BTCError: "", BTCStatus: true })
    //     } else this.setState({ BTCError: "*Please enter valid BTC value", BTCStatus: false })
    // }
    else if (type === "paymentMode") {
      if (this.state.paymentMode == "" || this.state.paymentMode == "Select") {
        this.setState({ paymentModeError: "*Please select Payment method." });
      } else this.setState({ paymentModeError: "" });
    } else if (type === "setPaymentWindow") {
      if (validatesetPaymentWindow(this.state.setPaymentWindow).status) {
        this.setState({
          setPaymentWindowError: "",
          setPaymentWindowStatus: true,
        });
      } else
        this.setState({
          setPaymentWindowError: validatesetPaymentWindow(
            this.state.setPaymentWindow
          ).error,
          setPaymentWindowStatus: false,
        });
    }
  };
  handleUserInput = (e) => {
    e.preventDefault();
    let type = e.target.name;
    let value = e.target.value;

    if (type == "trade_type") {
      if (isNaN(value) != true) {
        this.setState({ [type]: value }, () => {
          this.verify(type, value);
        });
      }
    } else if (type == "location") {
      if (isNaN(value) != true) {
        this.setState({ [type]: value }, () => {
          this.verify(type, value);
        });
      }
    }
    // else if (type == 'BTC') {
    //     //alert(">"+value+"<")
    //     if (!isNaN(value) && (value !== " ")) {
    //         this.setState({ [type]: value }, () => {
    //             this.verify(type, value)
    //         })
    //     }
    // }
    else if (type == "currency") {
      if (isNaN(value) != true) {
        this.setState({ [type]: value }, () => {
          this.verify(type, value);
        });
      }
    }

    // else if (type == 'margin') {

    //     if ((!isNaN(value) || (value == ".")) && (value <= 100) && (value != " ") && (value >= 0)) {

    //         if((value <= 100 )||(value == "-"))
    //         {
    //             var val = value.split("")
    //             if(val[0] == "-")
    //             {
    //                if((value*(-1) <= 100)||(value == "-"))
    //                {
    //                 this.setState({ [type]: value },()=>this.fetchAmount())
    //                }
    //             }
    //             else
    //             {
    //                 this.setState({ [type]: value },()=>this.fetchAmount())
    //             }

    //     }
    //     else if(value == "")
    //     {
    //         this.setState({ [type]: 0 },()=>this.fetchAmount())
    //     }
    //     }
    // }
    else if (type == "margin") {
      // alert(value)

      //     if (!isNaN(value) && (value != " ")) {
      //         if (value < 1000) {
      //             this.setState({ [type]: value }, () => {
      //                 this.verify(type, value)
      //             this.fetchAmount()
      //             })
      //     }

      // }

      if ((!isNaN(value) || value == "." || value == "-") && value != " ") {
        if (value <= 10000 || value == "-") {
          this.verify(type, value);
          var val = value.split("");
          if (val[0] == "-") {
            if (value * -1 <= 10000 || value == "-") {
              clearTimeout(this.timer);
              this.setState(
                {
                  [type]: value,
                },
                () => {
                  this.fetchAmount();
                }
              );

              // socket.emit('currentBTCValue', {
              //     amount:200,
              //     pricePerBtc:200
              //  })
            }
          } else {
            clearTimeout(this.timer);
            this.setState({ [type]: value }, () => {
              this.fetchAmount();
            });
          }

          setTimeout(() => {
            let timin = parseFloat(this.state.priceData);
            let timout = parseFloat(this.state.current);
            let Tottim = timin - timout;

            if (this.state.priceData == "0" || this.state.priceData == "")
              this.setState({ profit: 0 });
            else
              this.setState({
                priceData: this.state.priceData,
                profit: Tottim.toFixed(2),
              });
          }, 1000);
        } else if (value == "") {
          this.setState({ [type]: 0 }, () => this.fetchAmount());
        }
      }
    } else if (type == "minTransactionLimit") {
      if (!isNaN(value) && value != " ") {
        this.setState({ [type]: value }, () => {
          this.handleChange1([]);
          if (Number(this.state.minTransactionLimit) <= 0) {
            this.setState({
              minTransactionLimitError:
                "Please enter min. limit greater than zero",
            });
            return;
          } else if (
            Number(this.state.maxTransactionLimit) <
            Number(this.state.minTransactionLimit)
          ) {
            this.setState({
              maxTransactionLimitError:
                "Max. transaction limit should always be greater than or equal to Min. transaction limit",
            });
          } else {
            this.setState({
              minTransactionLimitError: "",
              maxTransactionLimitError: "",
            });
            this.verify(type, value);
          }
          // this.verify(type, value)
        });
      }
    } else if (type == "maxTransactionLimit") {
      if (!isNaN(value) && value !== " ") {
        if (this.state.minTransactionLimit !== "") {
          this.setState({ [type]: value, selectedOption: [] }, () => {
            this.handleChange1([]);
            if (
              Number(this.state.maxTransactionLimit) <
              Number(this.state.minTransactionLimit)
            ) {
              this.setState({
                maxTransactionLimitError:
                  "Max. transaction limit should always be greater than or equal to Min. transaction limit",
              });
            } else {
              this.setState({
                minTransactionLimitError: "",
                maxTransactionLimitError: "",
              });
              this.verify(type, value);
            }
          });
        } else {
          this.setState({
            maxTransactionLimitError:
              "Please enter the Min. transaction limit first",
          });
        }
      }
    } else if (type == "restrictAmount") {
      if (!isNaN(value) && value != " ") {
        this.setState({ [type]: value }, () => {
          this.verify(type, value);
        });
      }
    } else if (type == "termTrade") {
      var value1 = value.trim;
      if (value[0] != " ") {
        this.setState({ [type]: value }, () => {
          this.verify(type, value);
        });
      }
    }

    // else if (type == 'addTag') {

    //     this.setState({ [type]: value }, () => {
    //         this.verify(type, value)
    //     })

    // }
    else if (type == "paymentMode") {
      if (!isNaN(value)) {
        this.setState({ [type]: value }, () => {
          this.verify(type, value);
        });
      }
    } else if (type == "setPaymentWindow") {
      if (!isNaN(value) && value != " ") {
        if (value <= 360) {
          this.setState({ [type]: value }, () => {
            this.verify(type, value);
          });
        }
      }
    }
  };

  fetchAmount() {
    var parameter = {
      localCurrency: this.state.currency1,
      margin: this.state.margin,
    };
    if (this.state.currency1 !== "") {
      this.setState({ loading1: true });
      Api(
        "user/priceEquationWithMargin",
        "POST",
        parameter,
        this.state.token,
        this.state._id
      ).then((resp) => {
        this.setState({ loading1: false });

        if (resp.status === 200) {
          if (
            resp.data.responseCode === 409 ||
            resp.data.responseCode === 410 ||
            resp.data.responseCode === 411
          ) {
            localStorage.removeItem("data");
            localStorage.removeItem("isLoggedin");
            localStorage.removeItem("data1");
            localStorage.removeItem("token");
            toast_func("error", resp.data.responseMessage);
            setTimeout(() => {
              this.props.history.push("/");
            }, 1000);
          } else if (resp.data.responseCode == 502) {
            this.props.history.push("NotFound");
          }
          if (resp.data.responseCode === 200) {
            var num = Number(resp.data.result["price"]);
            var n = num.toFixed(2);
            var nn = num.toFixed(2);
            var n1 = n
              .split(".")[0]
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            var n2 = n.split(".")[1];
            var price = n1 + "." + n2;

            //this.setState({Amount})

            if (resp.data.result["margin"] == this.state.margin) {
              this.setState({
                price: price,
                price1: resp.data.result["price"],
                priceData: nn,
              });
              // let p = price.replace(/\,/g, '');
              // this.state.priceData;
            } else {
              this.fetchAmount();
            }
          }
        }
      });
    }
  }

  publish_Advertise = (e) => {
    //alert(">"+this.state.currency+"<")
    e.preventDefault();
    //alert(validateMargin(this.state.margin).status)

    if (!this.state.trade_type1 && !this.state.trade_type2) {
      this.setState({ trade_typeError: "*Please select at least one trade" });
    } else {
      this.setState({ trade_typeError: "" });
    }

    if (this.state.location == "" || this.state.location == "Select") {
      this.setState({ locationError: "*Please select location" });
    } else {
      this.setState({ locationError: "" });
    }

    if (this.state.currency == "" || this.state.currency == "Select") {
      this.setState({ currencyError: "*Please select currency" });
    } else {
      this.setState({ currencyError: "" });
    }

    // if (this.state.margin.toString() != "") {

    //     this.setState({ marginStatus: true, marginError: "" })
    // }
    // else {

    //     this.setState({ marginError: validateMargin(this.state.margin).error, marginStatus: false })
    // }

    if (validateMintransActionLimit(this.state.minTransactionLimit).status) {
      this.setState({
        minTransactionLimitStatus: true,
        minTransactionLimitError: "",
      });
    } else {
      this.setState({
        minTransactionLimitError: validateMintransActionLimit(
          this.state.minTransactionLimit
        ).error,
        minTransactionLimitStatus: false,
      });
    }

    if (
      validateMaxtransActionLimit(this.state.maxTransactionLimit).status == true
    ) {
      if (
        parseInt(this.state.minTransactionLimit) >
        parseInt(this.state.maxTransactionLimit)
      ) {
        this.setState({
          maxTransactionLimitStatus: false,
          maxTransactionLimitError:
            "*Please enter the max. limit greater than min. limit",
        });
      } else
        this.setState({
          maxTransactionLimitStatus: true,
          maxTransactionLimitError: "",
        });
    } else {
      this.setState({
        maxTransactionLimitError: validateMaxtransActionLimit(
          this.state.maxTransactionLimit
        ).error,
        maxTransactionLimitStatus: false,
      });
    }

    // if (validateRestrictAmount(this.state.restrictAmount).status == true) {
    //     this.setState({ restrictAmountStatus: true, restrictAmountError: "" })
    // }
    // else {
    //     this.setState({ restrictAmountError: validateRestrictAmount(this.state.restrictAmount).error, restrictAmountStatus: false })
    // }

    if (validatetermTrade(this.state.termTrade).status == true) {
      this.setState({ termTradeStatus: true, termTradeError: "" });
    } else {
      this.setState({
        termTradeError: validatetermTrade(this.state.termTrade).error,
        termTradeStatus: false,
      });
    }

    // if (validateaddTag(this.state.addTag).status == true) {
    //     this.setState({ addTagStatus: true, addTagError: "" })
    // }
    // else {
    //     this.setState({ addTagError: validateaddTag(this.state.addTag).error, addTagStatus: false })
    // }
    if (this.state.paymentMode == "" || this.state.paymentMode == "Select") {
      this.setState({ paymentModeError: "*Please select payment method" });
    } else {
      this.setState({ paymentModeError: "" });
    }
    if (validatesetPaymentWindow(this.state.setPaymentWindow).status == true) {
      this.setState({
        setPaymentWindowStatus: true,
        setPaymentWindowError: "",
      });
    } else {
      this.setState({
        setPaymentWindowError: validatesetPaymentWindow(
          this.state.setPaymentWindow
        ).error,
        setPaymentWindowStatus: false,
      });
    }
    let arr = [];
    if (this.state.selectedOption) {
      for (var i = 0; i < this.state.selectedOption.length; i++) {
        arr.push(this.state.selectedOption[i]["label"]);
      }
    }
    let arr1 = [];
    if (this.state.selectedOption1) {
      for (var i = 0; i < this.state.selectedOption1.length; i++) {
        arr1.push(this.state.selectedOption1[i]["label"]);
      }
    }
    setTimeout(() => {
      if (
        this.state.trade_typeError == "" &&
        this.state.locationError == "" &&
        this.state.currencyError == "" &&
        this.state.minTransactionLimitError == "" &&
        this.state.maxTransactionLimitError == "" &&
        this.state.termTradeError == "" &&
        this.state.addTagError == "" &&
        this.state.paymentModeError == "" &&
        this.state.setPaymentWindowError == ""
      ) {
        this.create_Advertise(arr, arr1);
      }
    }, 200);
  };
  verify1 = (e) => {
    e.preventDefault();
    let type = e.target.name;
    let value = e.target.value;

    //this.setState({ [type]: value });
    setTimeout(() => {
      if (type == "file_data4") {
        let _file_data = $(`#file_data4`).prop("files")[0];
        this.getBase64(_file_data, "file_data4");
        // let fileName = value.split(/(\\|\/)/g).pop();

        this.setState({ [type]: value });
        //     alert("@@@@@===="+this.state.file_data4)
        //   let array=this.state.imageArr
        //   array.push({img:this.state.file_data4})
        //   console.log("1111==="+JSON.stringify(array))
      }
    }, 200);
  };
  getBase64(file, type) {
    let self = this;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      let bse64data1 = reader.result.substr(reader.result).split(",")[0];
      let bse64data = reader.result.substr(reader.result.indexOf(",") + 1);
      let full_image = bse64data1 + bse64data;
      if (type == "file_data4") {
        self.setState({
          getBase64Data: bse64data,
          files4: bse64data1 + "," + bse64data,
          img4: full_image,
        });
        // self.setState({ files4: bse64data1 + "," + bse64data, img4: full_image })

        if (self.state.files4) {
          let array = self.state.product_images;
          var parameter = {
            image: self.state.files4,
          };
          Api("trade/uploadProductImage", "POST", parameter).then((resp) => {
            // this.setState({ loading: false })

            try {
              //   console.log("1111==="+JSON.stringify(resp))
              if ((resp.status = 200)) {
                if (resp.data.responseCode == 200) {
                  array.push({ imageUrl: resp.data.data });
                  console.log("1111===" + JSON.stringify(array));
                  self.setState({ product_images: array });
                } else if (resp.data.responseCode == 502) {
                  this.props.history.push("NotFound");
                } else toast_func("error", resp.data.responseMessage);
              } else toast_func("error", resp.data.responseMessage);
            } catch (ex) {
              //toast_func("error", "Some problem occured please contact administrator")
            }
          });
        }
      }
      // alert("####====" + self.state.files4)

      //self.setState({ file_dataError: '' })
    };
    reader.onerror = function(error) {
      // display toaster
    };
  }
  removeImg(e, ind) {
    e.preventDefault();
    let arr = this.state.product_images;
    arr.splice(ind, 1);
    this.setState({ product_images: arr });
    console.log("rem====>" + JSON.stringify(arr));
  }
  create_Advertise(arr, arr1) {
    // alert(">"+this.state.trade_type1+"<"+this.state.trade_type2)
    //return
    var parameter = {
      adId: this.state.adId,
      method_of_payment: this.state.paymentMode,
      paymentMethodId: this.state.paymentId,
      trade_type: this.state.trade_type1 ? "sell" : "buy",
      location: this.state.location,
      currency: this.state.currency1,
      margin: this.state.margin,
      priceEquation: this.state.price1,
      minTxnlimit: this.state.minTransactionLimit,
      maxTxnlimit: this.state.maxTransactionLimit,
      restrictAmount: arr1,
      termTrade: this.state.termTrade,
      addTag: arr,
      // "btcAmount": this.state.BTC,
      payment_time: this.state.setPaymentWindow,
      sms_verification: this.state.smsVerificationChecked,
      trusted_people: this.state.trustedPeopleChecked,
      identfifed_people: this.state.identityPeopleChecked,
      product_images: this.state.product_images,
    };
    this.setState({ loading: true });
    Api(
      "trade/update_ad",
      "POST",
      parameter,
      this.state.token,
      this.state._id
    ).then((resp) => {
      this.setState({ loading: false });
      try {
        if ((resp.status = 200)) {
          if (
            resp.data.responseCode == 409 ||
            resp.data.responseCode == 410 ||
            resp.data.responseCode == 411
          ) {
            localStorage.removeItem("data");
            localStorage.removeItem("data1");
            localStorage.removeItem("token");
            localStorage.removeItem("isLoggedin");
            this.props.history.push("/");
          } else if (resp.data.responseCode == 502) {
            this.props.history.push("NotFound");
          } else if (resp.data.responseCode == 200) {
            toast_func("success", resp.data.responseMessage);
            setTimeout(() => {
              this.props.history.push("/dashboard");
            }, 2500);
            //  this.setState({ modalIsOpen: true })
          } else {
            toast_func("error", resp.data.responseMessage);
          }
        } else {
          toast_func(
            "error",
            "Some problem occured please contact administrator"
          );
        }
      } catch (ex) {
        toast_func(
          "error",
          "Some problem occured please contact administrator"
        );
      }
    });
  }

  refinePrice(amount) {
    var num = Number(amount);
    var n = num.toFixed(2);
    var nn = num.toFixed(2);
    var n1 = n
      .split(".")[0]
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var n2 = n.split(".")[1];
    var price = n1 + "." + n2;
    return price;
  }

  handalMethod(e) {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ [name]: value });
    if (name == "paymentMode") {
      var array = this.state.paymentMethod;

      if (value == "") {
        this.setState({ paymentMethodS: array });
      }
      let filterVal = [];
      function search(nameKey, myArray) {
        console.log("Ritik===>", nameKey);
        for (var i = 0; i < myArray.length; i++) {
          if (myArray[i].name.toLowerCase().match(nameKey.toLowerCase())) {
            // return myArray[i];
            console.log("Ritik===>", myArray[i].name);
            filterVal.push(myArray[i]);
          }
        }
      }
      this.setState({ paymentMethodS: filterVal });

      var resultObject = search(value, array);
    }
  }

  onEditorChange = (evt) => {
    console.log("dataaa===>", evt);
    this.setState({
      termTrade: evt,
    });
  };

  setMethod = (e, item) => {
    // console.log("Ritik===>>",item)
    e.preventDefault();
    this.setState({
      paymentMode: item.name,
      bank: item.name,
      paymentId: item._id,
      paymethods: false,
    });
  };

  handleCallback = (val) => {
    if (val === "true") {
      document.body.style.setProperty("--primary-color", "#000");
      document.body.style.setProperty("--black-color", "#fff");
      document.body.style.setProperty("--white-color", "#000");
      document.body.style.setProperty("--text-grey", "#ffffffd4");
      document.body.style.setProperty("--table-hover", "#000000e3");
      document.body.style.setProperty("--popUpBW-color", "#fff");
    } else {
      document.body.style.setProperty("--popUpBW-color", "#3e5c85");
      document.body.style.setProperty("--primary-color", "#3e5c85");
      document.body.style.setProperty("--black-color", "#000");
      document.body.style.setProperty("--white-color", "#fff");
      document.body.style.setProperty("--text-grey", "#3a3a3a");
      document.body.style.setProperty("--table-hover", "#80808026");
    }
  };
  render() {
    return (
      <div>
        <Header {...this.props} parentCallback1={this.handleCallback} />
        <ToastContainer />
        {this.state.loading ? (
          <div className="loader">
            {" "}
            <img
              className=""
              style={{ height: 100, width: 100 }}
              src={require("../assets/lg.gif")}
            />{" "}
          </div>
        ) : null}
        <main className="mainContent">
          <section className="tradeAdBg">
            <div className="container1440 max-WT-1200">
              <div className="buySellBox">
                <h2 className="header2">Edit Bitcoin Trade Advertisement</h2>
              </div>
            </div>
          </section>

          {/* <section className="staticContentSection commonSectionStyle">
                        <div className="container1440 max-WT-1200">
                            <div className="sectionHead mb15">
                                <h2 className="font22 textInitial">Edit Bitcoin trade advertisement</h2>
                            </div> */}
          {/* <div className="border radius4 p15 mb15">
                                <img src={require("../assets/images/danger-icon.png")} className="mr7" />Please <Link to={"/login"}><a className="underline">LOGIN</a></Link> OR <Link to={"/signup"}><a className="underline">REGISTER</a></Link> before creating an advertisement.
                  </div> */}
          {/* <div className="sectionHead mb15">
                                <h2 className="font24 textInitial weight400">Advertisement rules and requirements</h2>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
                            </div> */}
          <section>
            <div className="container1440 max-WT-1200">
              <form className="mb0 createAdv">
                <div className="row">
                  <div className="col-md-10 marAuto">
                    <div className="cardBox mt40">
                      <div className="formBox">
                        <div className="sectionHead mb15">
                          <h2 className="font18 textInitial fontfamTB">
                            Advertisement Rules And Requirements
                          </h2>
                        </div>

                        <div className="formInnerNew">
                          <div className="row">
                            <div className="col-md-8">
                              <label className="control-label">
                                I want to{" "}
                              </label>
                              <div className="d-flex">
                                <div className="radio-design-block mb15">
                                  <label className="radio-design  largeRadio mb0 font14 fontfamQR">
                                    <input
                                      value={this.state.trade_type1}
                                      type="radio"
                                      name="trade_type"
                                      checked={`${
                                        this.state.trade_type1 ? "checked" : ""
                                      }`}
                                    />
                                    <span />
                                    Sell
                                  </label>
                                </div>
                                <div className="radio-design-block">
                                  <label className="radio-design largeRadio mb0 font14 fontfamQR">
                                    <input
                                      value={this.state.trade_type2}
                                      type="radio"
                                      name="trade_type"
                                      checked={`${
                                        this.state.trade_type2 ? "checked" : ""
                                      }`}
                                    />
                                    <span />
                                    Buy
                                  </label>
                                  {this.state.trade_typeError != "" ? (
                                    <label className="error">
                                      {this.state.trade_typeError}
                                    </label>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label className="control-label">Location</label>
                              {/* <div className="col-md-8">
                                                <input type="text" className="form-control" placeholder="Enter location" />
                                            </div> */}

                              <select
                                name="location"
                                value={this.state.location}
                                onChange={(e) => this.onClick_location(e)}
                                className="form-control select-style1"
                              >
                                <option>Select</option>
                                {this.Populate_location()}
                              </select>
                              {this.state.locationError != "" ? (
                                <label className="error">
                                  {this.state.locationError}
                                </label>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-10 marAuto">
                    <div className="cardBox  mt40">
                      <div className="formBox">
                        <div className="sectionHead">
                          <h2 className="font18 textInitial fontfamTB">
                            Security Options
                          </h2>
                        </div>
                        <div className="formInnerNew d-flex">
                          <div className="form-group row mb7 align-items-center">
                            <div className="col-2 col-md-2">
                              <div className="checkbox-design-block">
                                <label className="checkbox-design font16">
                                  <input
                                    name="identityPeopleChecked"
                                    value={this.state.identityPeopleChecked}
                                    onChange={() =>
                                      this.setState({
                                        identityPeopleChecked: !this.state
                                          .identityPeopleChecked,
                                      })
                                    }
                                    checked={`${
                                      this.state.identityPeopleChecked
                                        ? "checked"
                                        : ""
                                    }`}
                                    type="checkbox"
                                  />
                                  <span />
                                </label>
                              </div>
                            </div>
                            <label className="col-10 col-md-10 labelStyle fontfamQR">
                              Identified people only
                            </label>
                          </div>
                          <div className="form-group row mb7 align-items-center">
                            <div className="col-2 col-md-2">
                              <div className="checkbox-design-block">
                                <label className="checkbox-design font16">
                                  <input
                                    name="smsVerificationChecked"
                                    value={this.state.smsVerificationChecked}
                                    onChange={() =>
                                      this.setState({
                                        smsVerificationChecked: !this.state
                                          .smsVerificationChecked,
                                      })
                                    }
                                    checked={`${
                                      this.state.smsVerificationChecked
                                        ? "checked"
                                        : ""
                                    }`}
                                    type="checkbox"
                                  />
                                  <span />
                                </label>
                              </div>
                            </div>
                            <label className="col-10 col-md-10 labelStyle fontfamQR">
                              SMS verification needed
                            </label>
                          </div>
                          <div className="form-group row mb7 align-items-center">
                            <div className="col-2 col-md-2">
                              <div className="checkbox-design-block">
                                <label className="checkbox-design font16">
                                  <input
                                    name="trustedPeopleChecked"
                                    value={this.state.trustedPeopleChecked}
                                    onChange={() =>
                                      this.setState({
                                        trustedPeopleChecked: !this.state
                                          .trustedPeopleChecked,
                                      })
                                    }
                                    checked={`${
                                      this.state.trustedPeopleChecked
                                        ? "checked"
                                        : ""
                                    }`}
                                    type="checkbox"
                                  />
                                  <span />
                                </label>
                              </div>
                            </div>
                            <label className="col-10 col-md-10 labelStyle fontfamQR">
                              Trusted people only
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-10 marAuto">
                    <div className="cardBox mt40">
                      <div className="formBox">
                        <div className="sectionHead">
                          <h2 className="font18 textInitial fontfamTB">
                            More Information
                          </h2>
                        </div>
                        <div className="formInnerNew">
                          <div className="form-group row">
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-md-12">
                                  <label className="control-label">
                                    Payment Method (Trade With)
                                  </label>
                                  <input
                                    type="text"
                                    name="paymentMode"
                                    readOnly
                                    value={this.state.paymentMode}
                                    onClick={() =>
                                      this.setState({ paymethods: true })
                                    }
                                    className="form-control select-style1"
                                  >
                                    {/* <option>Select</option>
                                                    {this.Populate_paymentMethod()} */}
                                  </input>
                                  {this.state.paymentModeError != "" ? (
                                    <label className="error">
                                      {this.state.paymentModeError}
                                    </label>
                                  ) : null}
                                </div>
                                <div className="col-md-12 mt8">
                                  <label className="control-label">
                                    Margin
                                  </label>
                                  <div className="">
                                    <div className="input-per">
                                      <input
                                        type="number"
                                        maxLength={8}
                                        // inputMode="numeric"
                                        name="margin"
                                        value={this.state.margin}
                                        onChange={this.handleUserInput}
                                        className="form-control"
                                        placeholder="Margin"
                                      />
                                      <span> % </span>
                                    </div>

                                    <Modal
                                      isOpen={this.state.paymethods}
                                      fade={false}
                                      style={{
                                        alignSelf: "center",
                                        justifyContent: "center",
                                        margintop: "10%",
                                        maxWidth: "950px",
                                        margintop: "60px",
                                      }}
                                    >
                                      <div className="cardBox max-WT-950 center-box">
                                        <div className="cardHead center-box pb10 text-center posRel">
                                          <span
                                            className="crossBtn"
                                            onClick={() =>
                                              this.setState({
                                                paymethods: false,
                                              })
                                            }
                                          >
                                            <i className="fa fa-times" />
                                          </span>

                                          <h4 className="font18 mt0 mb5 text-center">
                                            Method
                                          </h4>
                                        </div>
                                        <form
                                          className="mb0"
                                          style={{
                                            height: "350px",
                                            overflowY: "auto",
                                            backgroundColor:
                                              "var(--white-color)",
                                          }}
                                        >
                                          <div className="formBox  max-WT-750 center-box">
                                            <div className="form-group mt20">
                                              <div className="input-per2">
                                                <input
                                                  type="text"
                                                  maxLength="15"
                                                  className="form-control modalSearch"
                                                  placeholder="All Online offers"
                                                  name="paymentMode"
                                                  value={this.state.paymentMode}
                                                  onChange={(e) =>
                                                    this.handalMethod(e)
                                                  }
                                                />
                                                <span>
                                                  <i className="fa fa-search" />
                                                </span>
                                              </div>
                                            </div>
                                            <div className="form-group">
                                              <div className="row">
                                                {this.state.paymentMethodS.map(
                                                  (item, index) => {
                                                    return (
                                                      <div
                                                        className="col-md-4"
                                                        key={index}
                                                      >
                                                        <button
                                                          className="paymethod"
                                                          title={item.name}
                                                          onClick={(e) =>
                                                            this.setMethod(
                                                              e,
                                                              item
                                                            )
                                                          }
                                                        >
                                                          <img
                                                            src={require("../assets/newImages/bitIcon.png")}
                                                            className=""
                                                          />{" "}
                                                          {item.name.length < 15
                                                            ? item.name
                                                            : item.name.slice(
                                                                0,
                                                                14
                                                              ) + ".."}
                                                        </button>
                                                      </div>
                                                    );
                                                  }
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </form>
                                      </div>
                                    </Modal>

                                    <ul className="detail-list mt5">
                                      <li>
                                        Current Bitcoin market price :{" "}
                                        {this.refinePrice(this.state.current)}{" "}
                                        {this.state.currency1}
                                      </li>
                                      <li>
                                        Your Bitcoin{" "}
                                        {this.state.trade_type1
                                          ? "selling"
                                          : "buying"}{" "}
                                        price:{" "}
                                        {this.refinePrice(this.state.priceData)}
                                      </li>
                                      {this.state.profit >= 0 ? (
                                        <li>
                                          How much you earn per one Bitcoin:{" "}
                                          {this.refinePrice(this.state.profit)}
                                        </li>
                                      ) : (
                                        <li>
                                          How much you loss per one Bitcoin:{" "}
                                          {this.refinePrice(this.state.profit)}
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-md-12">
                                  <label className="control-label">
                                    Currency
                                  </label>
                                  <div className="">
                                    <input
                                      type="text"
                                      className="form-control select-style1"
                                      placeholder="Select Currency"
                                      name="currency1"
                                      value={this.state.currency1}
                                      onClick={() =>
                                        this.setState({ currencyModal: true })
                                      }
                                    />

                                    {/* <select name="currency" value={this.state.currency1} onClick={() =>  this.setState({ currencyModal: true })} className="form-control select-style1"> */}
                                    {/* onChange={(e) => this.onClick_currency1(e)}  */}
                                    <Modal
                                      isOpen={this.state.currencyModal}
                                      fade={false}
                                      style={{
                                        alignSelf: "center",
                                        justifyContent: "center",
                                        margintop: "10%",
                                        maxWidth: "950px",
                                        margintop: "60px",
                                      }}
                                    >
                                      <div className="cardBox max-WT-950 center-box">
                                        <div className="cardHead center-box pb10 text-center posRel">
                                          <span
                                            className="crossBtn"
                                            onClick={() =>
                                              this.setState({
                                                currencyModal: false,
                                              })
                                            }
                                          >
                                            <i className="fa fa-times" />
                                          </span>

                                          <h4 className="font18 mt0 mb5 text-center">
                                            Currency
                                          </h4>
                                        </div>
                                        <CurrencyModal
                                          currencyJson={currencyJson}
                                          setValue={this.setValue}
                                        />
                                      </div>
                                    </Modal>
                                    {/* {this.Populate_currency1()} */}
                                    {/* </select> */}
                                    {this.state.currencyError != "" ? (
                                      <label className="error">
                                        {this.state.currencyError}
                                      </label>
                                    ) : null}
                                    <ul className="detail-list mt5">
                                      <li>
                                        {" "}
                                        Your offer to sell in the selected
                                        currency. For example, if you select US
                                        Dollars then your offer is visible for
                                        everyone willing to buy with US Dollar
                                        currency.
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                {/* <div className="form-group row align-items-center">
                                            <label className="col-md-4 control-label">Margin</label>
                                            <div className="col-md-8">
                                                <div className="input-per">
                                                    <input type="text" maxLength={8} inputMode="numeric" name="margin" value={this.state.margin} 
                                                    onChange={this.handleUserInput} className="form-control" placeholder="0"></input>
                                                    <span>  % </span>
                                                </div>                       
                                          

                                                      <ul className="detail-list mt5">
                                                                <li>Current Bitcoin market price : {this.refinePrice(this.state.current)}</li>
                                                                <li>Your Bitcoin selling price: {this.refinePrice(this.state.priceData)}</li>
                                                                {this.state.profit >= 0 ?
                                                                <li>How much you earn per one Bitcoin: {this.refinePrice(this.state.profit)}</li>
                                                                :
                                                                <li>How much you loss per one Bitcoin: {this.refinePrice(this.state.profit)}</li>
                                                                }
                                                            </ul>

                                            </div>

                                        </div> */}
                                <div className="col-md-12">
                                  <label className="control-label">
                                    Price/BTC
                                  </label>
                                  <div className="">
                                    <div className="load-img">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="0"
                                        name="Amount"
                                        value={this.state.price}
                                        disabled
                                      />
                                      {this.state.loading1 ? (
                                        <span>
                                          <img
                                            src={require("../assets/ajax-loader.gif")}
                                            style={{
                                              height: "25px",
                                              width: "25px",
                                            }}
                                            alt=""
                                          />
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row form-group">
                            <div className="col-md-6">
                              <label className="control-label">
                                Min. transaction limit
                              </label>
                              <div className="">
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={9}
                                  name="minTransactionLimit"
                                  value={this.state.minTransactionLimit}
                                  onChange={this.handleUserInput}
                                  className="form-control"
                                />
                                {this.state.minTransactionLimitError != "" ? (
                                  <label className="error">
                                    {this.state.minTransactionLimitError}
                                  </label>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label className="control-label">
                                Max. transaction limit
                              </label>
                              <div className="">
                                <input
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={9}
                                  name="maxTransactionLimit"
                                  value={this.state.maxTransactionLimit}
                                  onChange={this.handleUserInput}
                                  className="form-control"
                                />
                                {this.state.maxTransactionLimitError != "" ? (
                                  <label className="error">
                                    {this.state.maxTransactionLimitError}
                                  </label>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="row form-group">
                            <div className="col-md-6">
                              <label className="control-label">
                                Restrict amount to
                              </label>
                              <div className="">
                                <CreatableSelect
                                  value={this.state.selectedOption1}
                                  onChange={this.handleChange1}
                                  options={suggestions}
                                  isMulti
                                  isDisabled={
                                    this.state.minTransactionLimit !== "" &&
                                    this.state.maxTransactionLimit !== "" &&
                                    Number(this.state.minTransactionLimit) <=
                                      Number(this.state.maxTransactionLimit)
                                      ? false
                                      : true
                                  }
                                />
                                {/* <Creatable /> */}
                                {/* <input type="text" inputMode="numeric" name="restrictAmount" value={this.state.restrictAmount} onChange={this.handleUserInput} className="form-control" placeholder="" />
                                                {this.state.restrictAmountError != "" ?
                                                    <label className="error">{this.state.restrictAmountError}</label>
                                                    : null} */}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label className="control-label">
                                Product Image
                              </label>
                              <div className="d-flex">
                                {this.state.product_images.map(
                                  (item, index) => {
                                    return (
                                      <div className="addImg_l">
                                        <img
                                          src={`${item.imageUrl}`}
                                          className=""
                                        />
                                        <span>
                                          <i
                                            class="fa fa-times"
                                            onClick={(e) =>
                                              this.removeImg(e, index)
                                            }
                                          />
                                        </span>
                                      </div>
                                    );
                                  }
                                )}
                                {this.state.product_images.length < 6 ? (
                                  <div className="addmoreImage">
                                    <input
                                      type="file"
                                      id="file_data4"
                                      name="file_data4"
                                      accept=".jpg, .jpeg, .png"
                                      className="form-control"
                                      value={this.state.file_data4}
                                      onChange={this.verify1}
                                    />
                                    <i className="fas fa-plus" />
                                  </div>
                                ) : null}
                              </div>
                              <p style={{ color: "var(--text-grey)" }}>
                                * Photo size should not be more than 2 MB.{" "}
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <label className="control-label">
                                Terms of trade
                              </label>
                              <div className="">
                                <SunEditor
                                  name="termTrade"
                                  placeholder="Type somthing here..."
                                  defaultValue={this.state.termTrade}
                                  onChange={this.onEditorChange}
                                  setOptions={{
                                    height: "300px",
                                  }}
                                />
                                {/* <CKEditor
                                                            initData={<p>This is a CKEditor 4 WYSIWYG editor instance created by ️⚛️ React.</p>}
                                                            placeholder="Write here"
                                                                termTrade={this.state.termTrade}
                                                                onChange={this.onEditorChange}
                                                                maxLength={1500} className="form-control minHeight100"
                                                            /> */}
                                {/* <textarea inputMode="text" maxLength={500} className="form-control minHeight100" name="termTrade" value={this.state.termTrade} onChange={this.handleUserInput} placeholder=""></textarea> */}
                                {this.state.termTradeError != "" ? (
                                  <label className="error">
                                    {this.state.termTradeError}
                                  </label>
                                ) : null}
                                <ul className="detail-list mt5">
                                  <li>
                                    Trade instructions must be clear and
                                    bulleted if possible.Clear instructions are
                                    required for smooth transactions.
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="row form-group">
                            <div className="col-md-6">
                              <label className="control-label">Add tags</label>
                              <div className="">
                                {this.state.suggestions.length ? (
                                  // <ReactTags tags={this.state.tags}
                                  //     suggestions={this.state.suggestions}
                                  //     handleDelete={this.handleDelete}
                                  //     handleAddition={this.handleAddition}
                                  //     handleDrag={this.handleDrag}
                                  //     delimiters={delimiters}
                                  //     maxLength="20"
                                  //     inline={false}
                                  //     autofocus={false}
                                  //     // autocomplete={true}

                                  // />
                                  <Select
                                    value={this.state.selectedOption}
                                    onChange={this.handleChange}
                                    options={this.state.suggestions}
                                    isMulti
                                  />
                                ) : // $("#e9").select2()
                                //    <div className="tags-input" data-name="tags-input">
                                //    <span className="tag"></span>
                                //    </div>
                                null}
                                {this.state.addTagError != "" ? (
                                  <label className="error">
                                    {this.state.addTagError}
                                  </label>
                                ) : null}
                                <ul className="detail-list mt5">
                                  <li>
                                    Add quick tags that describe your offer
                                    terms such as "No verification required",
                                    "Physical Cards only".
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {/* <div className="form-group row align-items-center">
                                            <label className="col-md-4 control-label">BTC Amount</label>
                                            <div className="col-md-8">
                                                <input inputMode="numeric" type="text" name="BTC" value={this.state.BTC} className="form-control" onChange={this.handleUserInput} placeholder="Enter BTC" />
                                                {this.state.BTCError != "" ?
                                                    <label className="error">{this.state.BTCError}</label>
                                                    : null}
                                            </div>

                                        </div> */}
                            <div className="col-md-6">
                              <label className="control-label">
                                Set payment window
                              </label>
                              <div className="">
                                <input
                                  inputMode="numeric"
                                  type="text"
                                  maxLength={3}
                                  name="setPaymentWindow"
                                  value={this.state.setPaymentWindow}
                                  onChange={this.handleUserInput}
                                  className="form-control"
                                  placeholder="30-360 minutes"
                                />
                                {this.state.setPaymentWindowError != "" ? (
                                  <label className="error">
                                    {this.state.setPaymentWindowError}
                                  </label>
                                ) : null}
                                <ul className="detail-list mt5">
                                  <li>
                                    This is the time you offer, to pay and
                                    complete the trade. Trade will auto-cancel
                                    if buyer has not clicked "I have paid"
                                    before payment window expires.
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div className="row form-group">
                            <div className="col-md-6">
                              <div className="mt25">
                                <button
                                  type="submit"
                                  className="btn btnGreen radius4"
                                  onClick={(e) => this.publish_Advertise(e)}
                                >
                                  Save advertisement
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </section>
        </main>
        <Footer {...this.props} />
      </div>
    );
  }
}
